import { slate } from './colours';

/** Nav labels, society outline, icons, and subnav tree on the light-mode blue registry rail */
export const registrySidebarLightRailForeground = slate[200];

/**
 * Default nav label and icon colour on the dark registry rail — slightly brighter than
 * `theme.palette.text.secondary` so icons and text stay readable on the tinted primary background.
 */
export const registrySidebarDarkRailForeground = slate[200];
